export default "__VITE_ASSET__282261ed__"